import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteAccountingHeaderFormModal
    from 'src/features/accountingHeaders/components/forms/DeleteAccountingHeaderFormModal';
import { AccountingHeading } from 'src/features/accountingHeaders/utils/types';
import UpdateAccountingHeaderFormModal
    from 'src/features/accountingHeaders/components/forms/UpdateAccountingHeaderFormModal';
import { accountingHeadersMessages } from 'src/features/accountingHeaders/utils/messages';

export default function CellAccountingHeaderActions({ row }: CellContext<AccountingHeading, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateAccountingHeaderFormModal
                        semantics={{ entryName: formatMessage(accountingHeadersMessages.header).toLowerCase() }}
                        selectedAccountingHeader={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateAccountingHeaderFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteAccountingHeaderFormModal selectedAccountingHeader={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteAccountingHeaderFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
